import { Component, OnInit } from '@angular/core';
import { AppConfigService } from 'src/app/services/configuration/app-config.service';
import { Router } from '@angular/router';

@Component({
  selector: 'app-success-property-manager',
  templateUrl: './success-property-manager.component.html',
  styleUrls: ['./success-property-manager.component.scss']
})
export class SuccessPropertyManagerComponent implements OnInit {
  successContent = AppConfigService.settings.workFlow.confirmation.manager;
  constructor(
    private router: Router,
  ) { }

  navigateToComingSoon() {
    this.router.navigate(['/coming-soon']);
  }

  ngOnInit() {
  }

}
